import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \Lab404\Impersonate\Controllers\ImpersonateController::leave
* @see vendor/lab404/laravel-impersonate/src/Controllers/ImpersonateController.php:67
* @route '/impersonate/leave'
*/
export const leave = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: leave.url(options),
    method: 'get',
})

leave.definition = {
    methods: ["get","head"],
    url: '/impersonate/leave',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Lab404\Impersonate\Controllers\ImpersonateController::leave
* @see vendor/lab404/laravel-impersonate/src/Controllers/ImpersonateController.php:67
* @route '/impersonate/leave'
*/
leave.url = (options?: RouteQueryOptions) => {
    return leave.definition.url + queryParams(options)
}

/**
* @see \Lab404\Impersonate\Controllers\ImpersonateController::leave
* @see vendor/lab404/laravel-impersonate/src/Controllers/ImpersonateController.php:67
* @route '/impersonate/leave'
*/
leave.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: leave.url(options),
    method: 'get',
})

/**
* @see \Lab404\Impersonate\Controllers\ImpersonateController::leave
* @see vendor/lab404/laravel-impersonate/src/Controllers/ImpersonateController.php:67
* @route '/impersonate/leave'
*/
leave.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: leave.url(options),
    method: 'head',
})

/**
* @see \Lab404\Impersonate\Controllers\ImpersonateController::leave
* @see vendor/lab404/laravel-impersonate/src/Controllers/ImpersonateController.php:67
* @route '/impersonate/leave'
*/
const leaveForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: leave.url(options),
    method: 'get',
})

/**
* @see \Lab404\Impersonate\Controllers\ImpersonateController::leave
* @see vendor/lab404/laravel-impersonate/src/Controllers/ImpersonateController.php:67
* @route '/impersonate/leave'
*/
leaveForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: leave.url(options),
    method: 'get',
})

/**
* @see \Lab404\Impersonate\Controllers\ImpersonateController::leave
* @see vendor/lab404/laravel-impersonate/src/Controllers/ImpersonateController.php:67
* @route '/impersonate/leave'
*/
leaveForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: leave.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

leave.form = leaveForm

/**
* @see routes/admin.php:235
* @route '/impersonate/redirect'
*/
export const redirect = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: redirect.url(options),
    method: 'get',
})

redirect.definition = {
    methods: ["get","head"],
    url: '/impersonate/redirect',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/admin.php:235
* @route '/impersonate/redirect'
*/
redirect.url = (options?: RouteQueryOptions) => {
    return redirect.definition.url + queryParams(options)
}

/**
* @see routes/admin.php:235
* @route '/impersonate/redirect'
*/
redirect.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: redirect.url(options),
    method: 'get',
})

/**
* @see routes/admin.php:235
* @route '/impersonate/redirect'
*/
redirect.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: redirect.url(options),
    method: 'head',
})

/**
* @see routes/admin.php:235
* @route '/impersonate/redirect'
*/
const redirectForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: redirect.url(options),
    method: 'get',
})

/**
* @see routes/admin.php:235
* @route '/impersonate/redirect'
*/
redirectForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: redirect.url(options),
    method: 'get',
})

/**
* @see routes/admin.php:235
* @route '/impersonate/redirect'
*/
redirectForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: redirect.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

redirect.form = redirectForm

const impersonate = {
    leave: Object.assign(leave, leave),
    redirect: Object.assign(redirect, redirect),
}

export default impersonate